import { render, staticRenderFns } from "./CreateBusbarTempModule.vue?vue&type=template&id=5cbc404d"
import script from "./CreateBusbarTempModule.vue?vue&type=script&lang=js"
export * from "./CreateBusbarTempModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports